/**
 * Коды автоматизации
 */
export default class AutomationCodes
{
    public static readonly DETECTIVE_CLUB = 'DetectiveClub';
    public static readonly SIMILO = 'Similo';
    public static readonly MAFIA = 'Mafia';
    public static readonly CROCO = 'crocodile';
    public static readonly CHAMELEON = 'chameleon';
    public static readonly ON_TIME = 'on_time';
    public static readonly ANGELS_AND_DEMONS = 'angels_and_demons';
}
